import { applySnapshot, getSnapshot, types as t } from 'mobx-state-tree';

const RejectReasonType = t.model('RejectReasonType', {
  id: t.string,
  name: t.string,
  description: t.string,
});

export const RejectReasonTypesModel = t
  .model('RejectReasonTypesModel', {
    list: t.array(RejectReasonType),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
    };
  });

export default RejectReasonTypesModel;
